import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24h para persistência
      staleTime: 5 * 60 * 1000, // 5 minutos por padrão
      retry: (failureCount, error) => {
        // Não retry para erros 4xx (client errors)
        if (error instanceof Error && 'status' in error) {
          const status = (error as Error & { status: number }).status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 2; // Max 2 retries
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 10000), // Max 10s
      refetchOnWindowFocus: false, // Não refetch ao focar na janela
      refetchOnMount: false, // Não refetch ao montar se já tem dados
      refetchOnReconnect: false, // Não refetch ao reconectar
    },
  },
});
